import { useEffect } from "react";
import { useAuthOptions } from "../auth/useAuthOptions";
import { AuthLayout } from "../components/ui";

/**
 * /termeni and /confidentialitate in the app (linked from sign-up): the documents themselves live on the
 * marketing site, so the page opens them there. Without a site (local setups) it says where to ask for them.
 */
export function LegalDraftPage({ title, doc }: { title: string; doc: "terms" | "privacy" }) {
  const options = useAuthOptions();
  const url = options ? (doc === "terms" ? options.termsUrl : options.privacyUrl) : null;
  useEffect(() => {
    if (url) window.location.replace(url);
  }, [url]);
  return (
    <AuthLayout>
      <h1 className="h1">{title}</h1>
      {url ? (
        <p className="muted" role="status" style={{ margin: 0 }}>
          Se deschide documentul… Dacă nu se deschide, <a href={url}>apasă aici</a>.
        </p>
      ) : options ? (
        <p className="muted" style={{ margin: 0 }}>
          Documentul este publicat pe meniova.com. Online Growth Solutions SRL operează Meniova.
        </p>
      ) : (
        <p className="muted" role="status" style={{ margin: 0 }}>
          Se încarcă…
        </p>
      )}
      <p className="auth-foot">
        <button type="button" className="link-btn" onClick={() => window.history.back()}>
          Înapoi
        </button>
      </p>
    </AuthLayout>
  );
}
